import React from 'react';
import {t} from '@lingui/core/macro';
import {Trans} from '@lingui/react';

import ConfirmModal from 'shared/ui/Modal/ConfirmModal/ConfirmModal';
import {ExceededModal} from 'entities/user';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';
import {HttpMonitorResumeGoal, useHttpMonitorResume} from 'features/http/model/useHttpMonitorMutations';

interface IHttpMonitorResumeModalProps {
    item: IHttpMonitorOutput,
    open: boolean,
    handleClose: () => void,
    goal?: HttpMonitorResumeGoal,
}

const HttpMonitorResumeModal: React.FC<IHttpMonitorResumeModalProps> = ({item, open, handleClose, goal}) => {
    const {resume, isLoading, isExceededOpen, closeExceeded} = useHttpMonitorResume({item, handleClose, goal});

    return (
        <>
            <ConfirmModal
                variant="resume"
                open={open}
                handleClose={handleClose}
                header={t`Возобновление монитора`}
                title={<Trans id="modal.monitor.resume.title" message="Вы уверены, что хотите возобновить монитор"/>}
                name={item.name || item.url}
                confirmText={t`Возобновить`}
                onConfirm={resume}
                isLoading={isLoading}
            />
            <ExceededModal
                isOpen={isExceededOpen}
                handleClose={closeExceeded}
            />
        </>
    );
};

export default HttpMonitorResumeModal;
